import { apiGet, apiPut } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';

import { FuelSummaryData } from '../../../common/application/model/integration/mapon/FuelSummaryResponse';
import { UnitRoute } from '../../../common/application/model/integration/mapon/UnitRoute';

export async function getMaponVehicleUsage(
    customerId: string,
    maponUnitId?: number,
): Promise<{ fuelSummary: FuelSummaryData; routeList: UnitRoute[] }> {
    const queryParams = { customerId, maponUnitId };
    const response = await apiGet('/api/mapon/vehicle-usage', queryParams);

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getMaponApiKey(customerId: string): Promise<{ apiKey: string }> {
    const response = await apiGet(`/api/mapon/api-key/${customerId}`);

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function saveMaponApiKey(customerId: string, maponApiKey: string): Promise<{ success: number }> {
    const response = await apiPut(`/api/mapon/api-key/${customerId}`, { maponApiKey });

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
